// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_UNITS = "GET_UNITS";
export const CREATE_UNITS = "CREATE_UNITS";
export const UPDATE_UNITS = "UPDATE_UNITS";
export const DELETE_UNITS = "DELETE_UNITS";
export const CREATE_DEPARTMENT = "CREATE_DEPARTMENT";
